module.exports = __webpack_public_path__ + "static/media/logo.a8f6d70c.jpg";